import * as React from 'react';
import useCollapse from 'react-collapsed';
import { UseCollapseOutput } from 'react-collapsed/dist/types';

import { IconName } from '../../../../enums';

import { Container, Content, ContentContainer, ContentWrapper, StyledIcon, Title } from './accordionItem.styled';
import { AccordionItemProps } from './accordionItem.types';

export const AccordionItem: React.FC<AccordionItemProps> = (props: AccordionItemProps): JSX.Element => {
  const { title, content, className }: AccordionItemProps = props;
  const { getCollapseProps, setExpanded, isExpanded }: UseCollapseOutput = useCollapse();

  const onCollapseAction: () => void = (): void => {
    setExpanded(!isExpanded);
  };

  return (
    <Container className={className}>
      <Title onClick={onCollapseAction}>
        {title}
        <StyledIcon name={isExpanded ? IconName.Close : IconName.AddLines} size={24} />
      </Title>
      <ContentContainer {...getCollapseProps()}>
        <ContentWrapper>
          <Content text={content} />
        </ContentWrapper>
      </ContentContainer>
    </Container>
  );
};
